const defaultState = [];

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'FAXES_FAILURE_SUMMARY_SUCCESS':
            return action.faxesFailureSummary || defaultState;
        case 'FAXES_FAILURE_SUMMARY_ERROR':
            return [];
        default:
            return state;
    }
}
